export default __webpack_public_path__ + "static/media/store-24-hour.84af79c3.svg";